export default __webpack_public_path__ + "icon-share.c578efab.png";